const { logger } = require('internal-logger');

module.exports = logger;

